import { toTypedSchema } from '@vee-validate/zod'
import { object, string } from 'zod'
import { nameValidationSchema } from '@/schemas/common'

export const helpSchema = toTypedSchema(
  object({
    name: nameValidationSchema,
    subject: string().min(1, { message: 'common.validation.mandatory' }),
    message: string().min(1, { message: 'common.validation.mandatory' }),
  })
)
